import moment from 'moment-timezone/builds/moment-timezone-with-data'
import querystring from 'querystring'

export const pad = (num) => {
  const s = `00${num}`
  return s.substr(s.length - 2)
}

export const formatTime = (time) => {
  return `${pad(time.hours)}:${pad(time.minutes)}`
}

export const formatDateTime = (datetime, timezone) => {
  const { date, time } = datetime

  const d = moment.tz(date, timezone)
  d.hours(parseInt(time.split(':')[0], 10))
  d.minutes(parseInt(time.split(':')[1], 10))
  d.seconds(0)

  return d.format()
}

export function formatToDateTime(dateString, timezone) {
  if (!dateString) {
    return { date: null, time: null }
  }

  const date = new Date(dateString)
  const formattedDate = moment.tz(date, timezone)
  const time = formatTime({
    hours: formattedDate.hours(),
    minutes: formattedDate.minutes(),
  })

  return { date, time }
}

export const formatDateTimeHuman = (date, locale, timezone) => {
  return moment.tz(date, timezone).locale(locale).format('LLLL')
}

export const timeRange = (start, end, step) => {
  const startMinutes = start.hours * 60 + start.minutes
  const endMinutes = end.hours * 60 + end.minutes
  const times = []

  for (let i = startMinutes; i <= endMinutes; i += step) {
    times.push(formatTime({
      hours: parseInt(i / 60, 10),
      minutes: parseInt(i % 60, 10),
    }))
  }

  return times
}

export const formatAddress = (address) => {
  return `${address.street.long_name} ` +
    `${address.number.long_name}, ` +
    `${address.zip.long_name}, ` +
    `${address.city.long_name} (${address.province.short_name})`
}

export const formatLocation = (location) => {
  return `${location.title}, ` +
    `${location.address.city.long_name} (${location.address.province.short_name})`
}

export const languageByCode = (code, languages = []) => {
  let result = undefined
  languages.forEach((language) => {
    if (language.value === code) {
      result = language
    }
  })
  return result
}

export const imgixImg = (src, w, h, fit = 'cover', fm = 'pjpg') => {
  const params = { fit, w, h, fm }

  return `${src}?${querystring.stringify(params)}`
}

export const croppedImg = (src, w, h, fm) => {
  return imgixImg(src, w, h, 'crop', fm)
}

export const coveredImg = (src, w, h, fm) => {
  return imgixImg(src, w, h, 'cover', fm)
}

export const getBBURL = () => {
  return `https://bookingbutton.winearound.com${location.pathname}${location.search}`
}

export const triggerEvent = (target, type) => {
  const doc = window.document
  if (doc.createEvent) {
    const event = doc.createEvent('HTMLEvents')
    event.initEvent(type, true, true)
    target.dispatchEvent(event)
  } else {
    const event = doc.createEventObject()
    target.fireEvent(`on${type}`, event)
  }
}

export const isPaymentDisabled = ({ propose, payment, dates = [] }, { start }) => {
  if (propose) {
    return payment.enabled
  }

  const startDate = new Date(start)
  const startDateTime = startDate.getTime()
  const date = dates.find(({ d }) => {
    const thisDate = new Date(d)
    return thisDate.getTime() === startDateTime
  })

  return date && !date.pay
}
